import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { ValueStrip } from "./components/ValueStrip";
import { Features } from "./components/Features";
import { AppShowcase } from "./components/AppShowcase";
import { HowItWorks } from "./components/HowItWorks";
import { WhyBanga } from "./components/WhyBanga";
import { SecuritySection } from "./components/SecuritySection";
import { Faq } from "./components/Faq";
import { FinalCta } from "./components/FinalCta";
import { Footer } from "./components/Footer";
import { LegalPage } from "./components/LegalPage";
import { ContactPage } from "./components/ContactPage";
import { site } from "./content/site";
import { scrollToHash } from "./lib/scroll";

const legalRoutes = {
  "/privacy-policy": "privacy",
  "/terms-and-conditions": "terms",
};

const contactRoute = "/contact-us";

const HomePage = () => (
  <main>
    <Hero />
    <Marquee />
    <ValueStrip />
    <Features />
    <AppShowcase />
    <HowItWorks />
    <WhyBanga />
    <SecuritySection />
    <Faq />
    <FinalCta />
  </main>
);

function App() {
  const pathname =
    window.location.pathname.length > 1
      ? window.location.pathname.replace(/\/$/, "")
      : window.location.pathname;
  const page = legalRoutes[pathname];
  const isContactPage = pathname === contactRoute;

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.12, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    if (page) {
      const title = page === "privacy" ? site.legal.privacy.title : site.legal.terms.title;
      document.title = `${title} | Banga Pay`;
      window.scrollTo({ top: 0 });
      return;
    }

    if (isContactPage) {
      document.title = `${site.contactPage.eyebrow} | Banga Pay`;
      window.scrollTo({ top: 0 });
      return;
    }

    document.title = site.seo.title;
    if (window.location.hash) {
      window.requestAnimationFrame(() => scrollToHash(window.location.hash));
    }
  }, [isContactPage, page]);

  return (
    <div className="min-h-screen bg-white font-body text-gray-900 antialiased">
      <Navbar />
      {page ? <LegalPage page={page} /> : isContactPage ? <ContactPage /> : <HomePage />}
      <Footer />
    </div>
  );
}

export default App;
